import { CheckCheckIcon, CopyIcon } from "lucide-react";
import { useState } from "react";
import { useCopyToClipboard } from "usehooks-ts";
import { Button, ButtonProps } from "web-design-system";

export function CopyButton({
  text,
  icon = <CopyIcon />,
  variant = "outline",
}: {
  text: string;
  icon?: React.ReactNode;
  variant?: ButtonProps["variant"];
}) {
  const [, copy] = useCopyToClipboard();

  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    await copy(text);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 3000);
  };

  return (
    <Button
      className="shrink-0"
      size="icon"
      type="button"
      variant={variant}
      aria-label="Copy"
      onClick={handleCopy}
    >
      {isCopied ? <CheckCheckIcon /> : icon}
    </Button>
  );
}

export function AnimatedCopyButton({
  text,
  label,
}: {
  text: string;
  label: string;
}) {
  const [, copy] = useCopyToClipboard();

  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    await copy(text);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 3000);
  };

  return (
    <Button
      className="shrink-0 gap px-2 group gap-0 hover:gap-2 transition-all duration-300 ease-linear overflow-hidden"
      size="sm"
      type="button"
      variant="outline"
      onClick={handleCopy}
    >
      {isCopied ? <CheckCheckIcon /> : <CopyIcon />}
      <span className="max-w-0 group-hover:max-w-sm transition-all duration-300 overflow-hidden ease-linear whitespace-nowrap">
        {label}
      </span>
    </Button>
  );
}
